import { render, staticRenderFns } from "./TekeytyminenAlert.vue?vue&type=template&id=048af334&scoped=true&"
import script from "./TekeytyminenAlert.vue?vue&type=script&lang=js&"
export * from "./TekeytyminenAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048af334",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048af334')) {
      api.createRecord('048af334', component.options)
    } else {
      api.reload('048af334', component.options)
    }
    module.hot.accept("./TekeytyminenAlert.vue?vue&type=template&id=048af334&scoped=true&", function () {
      api.rerender('048af334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TekeytyminenAlert.vue"
export default component.exports